import TextAndImage from './MultiMediaDisplay';

export default TextAndImage;
